// SignupStepOne.tsx
import React, { useState } from 'react';
import { FaRegCheckCircle } from 'react-icons/fa';
import LoyaltyCard from './LoyaltyCard';
import EmailVerificationForm from './EmailVerificationForm';
import Modal from '../../../components/Modal';
import { NavLink } from 'react-router-dom';

interface SignupStepOneProps {
  onEmailVerify: (email: string) => void;
}

const SignupStepOne: React.FC<SignupStepOneProps> = ({ onEmailVerify }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  // 모달을 열고 닫는 함수
  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  return (
      <div>
        <div>
          <h1 className=" text-center text-5xl mobile:text-2xl mobile:mb-2 Pretendard-Bold tracking-wide mb-5 mt-[200px] mobile:mt-[160px] text-[#141414]">
            크리에이터 유닛 스튜디오
          </h1>
          <p className="text-center text-[#757575] Pretendard-Regular text-xl mobile:text-sm mb-4">
            간단한 인증을 통하여 사이트를 이용할 수 있습니다.
          </p>
          <h2 className="text-left text-2xl mobile:text-base mobile:mt-10 Pretendard-Bold mb-8 mt-16 text-[#111]">본인인증</h2>
          <div className="flex gap-4 Pretendard-Bold text-xl mobile:text-base justify-center">
            <LoyaltyCard
                title="이메일 인증"
                icon={<FaRegCheckCircle className="text-green-500 text-4xl mobile:text-3xl mb-2" />}
                onClick={openModal} // 클릭 시 모달 오픈
            />
          </div>
        </div>

        <div className='text-center mt-[80px] mobile:mt-[80px]'>
          <div onClick={() => (window.location.href = '/')} className='text-sm cursor-pointer Pretendard-Regular tracking-wide text-[#ccc['>
          홈으로 가기
          </div>
        </div>

        {/* 모달 컴포넌트 */}
        <Modal isOpen={isModalOpen} onClose={closeModal} width="500px" height="280px">
          <EmailVerificationForm
              onEmailVerify={(email: string) => {
                onEmailVerify(email);
                closeModal();
              }}
          />
        </Modal>

      </div>
  );
};

export default SignupStepOne;
